// src/components/ads/AdFit.jsx
import React, { useEffect } from 'react';

const AdFit = ({ unit, width, height }) => {
  useEffect(() => {
    // 카카오 애드핏 스크립트 로드
    if (!window.kakaoAdfit) {
      const script = document.createElement('script');
      script.src = "//t1.daumcdn.net/kas/static/ba.min.js";
      script.async = true;
      document.body.appendChild(script);
      window.kakaoAdfit = true;
    }

    // 광고 렌더링
    const render = () => {
      if (window.kakao && window.kakao.renderAd) {
        window.kakao.renderAd();
      }
    };

    // 스크립트 로드 완료 후 광고 렌더링
    const timer = setInterval(() => {
      if (window.kakao && window.kakao.renderAd) {
        render();
        clearInterval(timer);
      }
    }, 100);

    // 컴포넌트 언마운트 시 타이머 정리
    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, [unit]);

  // unit, width, height가 없으면 렌더링하지 않음
  if (!unit || !width || !height) {
    return null;
  }

  return (
    <div className="adfit-container flex justify-center" style={{ minHeight: `${height}px`, width: `${width}px` }}>
      <ins 
        className="kakao_ad_area" 
        style={{ 
          display: "block",
          width: `${width}px`,
          height: `${height}px`,
          background: '#f1f1f1'
        }}
        data-ad-unit={unit}
        data-ad-width={width}
        data-ad-height={height}
      />
    </div>
  );
};

// PC용 상단 광고
export const InArticleDesktopAd = () => (
  <div className="hidden md:block py-2">
    <AdFit
      unit={process.env.REACT_APP_ADFIT_PC_ID}
      width="728"
      height="90"
    />
  </div>
);

// 모바일용 상단 광고
export const InArticleMobileAd = () => (
  <div className="block md:hidden py-2">
    <AdFit
      unit={process.env.REACT_APP_ADFIT_MOBILE_ID}
      width="320"
      height="100"
    />
  </div>
);

// PC용 좌측 사이드바 광고 추가
export const LeftSidebarAd = () => (
  <div className="sticky top-4">
    <AdFit
      unit={process.env.REACT_APP_ADFIT_LEFT_SIDEBAR_ID}
      width="160"
      height="600"
    />
  </div>
);

// 사이드바 광고 (PC 전용)
export const RightSidebarAd = () => (
  <div className="sticky top-4">
    <AdFit
      unit={process.env.REACT_APP_ADFIT_SIDEBAR_ID}
      width="160"
      height="600"
    />
  </div>
);

export default AdFit;